import { MessageMedia } from '@/shared/interfaces/MessageMedia'
import { ApiHandler } from '../ApiHandler'

export abstract class MediasApi {
  public static async get(
    chatId: number,
    filetype: 'photo' | 'video' | 'audio' | 'document',
    page: number,
  ): Promise<{
    page: number;
    page_count: number;
    medias: MessageMedia[];
  }> {
    return await ApiHandler.get(
      `chats/${chatId}/medias/${filetype}`, {page, chat_id: chatId, filetype},
    )
  }
}
